import React from 'react'
import { connect } from 'react-redux'
import InfoPanel from '../../components/InfoPanel'
import OpisKryteriowObjeciaSprFin from '../../components/KryteriaKonsolidacji/OpisKryteriowObjeciaSprFin'
import OpisKryteriowWylaczen from '../../components/KryteriaKonsolidacji/OpisKryteriowWylaczen'
import * as actions from '../../store/actions'
import MainStyle from '../../styles/MainStyle'

function KryteriaKonsolidacji({
  sectionList,
  validityErrors,
  onSetSectionData,
  czyPodsumowanie,
}) {
  function expandContent() {
    return (
      <>
        {rolledContent()}
        <br />
        <div>
          Można nie ujawniać informacji na temat kryteriów zastosowanych przez
          jednostkę dominującą do objęcia skonsolidowanym sprawozdaniem
          finansowym jednostek zależnych, jeżeli jednostka dominująca sprawuje
          kontrolę nad jednostką z tytułu posiadania bezpośrednio lub pośrednio
          większości ogólnej liczby głosów w organie stanowiącym innej jednostki
          (zależnej), także na podstawie porozumień z innymi uprawnionymi do
          głosu, wykonującymi swe prawa głosu zgodnie z wolą jednostki
          dominującej oraz jeżeli udział w całkowitej liczbie głosów jest równy
          udziałowi w kapitale (funduszu) podstawowym
        </div>
      </>
    )
  }

  function rolledContent() {
    return (
      <div>
        W tym miejscu należy podać informacje na temat kryteriów zastosowanych
        przez jednostkę dominującą do objęcia skonsolidowanym sprawozdaniem
        finansowym jednostek zależnych, a także przedstawić stosowane kryteria
        wyłączeń jednostek podporządkowanych ze skonsolidowanego sprawozdania
        finansowego
      </div>
    )
  }

  return (
    <MainStyle>
      <InfoPanel
        canExpand={true}
        exptandContent={expandContent()}
        rolledContent={rolledContent()}
      />
      {sectionList.map((data, index) => {
        switch (data.TypSekcji) {
          case 'OpisKryteriowObjeciaSprFin':
            return (
              <OpisKryteriowObjeciaSprFin
                key={index}
                data={data.Dane}
                errors={validityErrors.filter(
                  (value) => value.TypSekcji === 'OpisKryteriowObjeciaSprFin',
                )}
                onSetSectionData={(name, value) =>
                  onSetSectionData(name, value, index)
                }
                czyPodsumowanie={czyPodsumowanie}
              />
            )
          case 'OpisKryteriowWylaczen':
            return (
              <OpisKryteriowWylaczen
                key={index}
                data={data.Dane}
                errors={validityErrors.filter(
                  (value) => value.TypSekcji === 'OpisKryteriowWylaczen',
                )}
                onSetSectionData={(name, value) =>
                  onSetSectionData(name, value, index)
                }
                czyPodsumowanie={czyPodsumowanie}
              />
            )
          default:
            return null
        }
      })}
    </MainStyle>
  )
}

const mapStateToProps = (state) => ({
  validityErrors: state.sprawozdanie.validityErrors
    ? state.sprawozdanie.validityErrors
    : [],
  czyPodsumowanie: state.sprawozdanie.czyPodsumowanie,
})

const mapDispatchToProps = (dispatch) => ({
  onSetSectionData: (name, value, index) =>
    dispatch(actions.setSectionData(name, value, index)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(KryteriaKonsolidacji)
